"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 2,
  x: 3,
  y: 21,
  fill: "var(--sds--ursa-icons--selected-color, currentColor)",
  rx: 1
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M14.013 4.63a2.15 2.15 0 0 1 3.039 0l1.319 1.318c.839.84.839 2.2 0 3.039l-7.672 7.672c-.276.276-.62.47-.999.565l-2.93.733a1.424 1.424 0 0 1-1.727-1.727l.733-2.93c.094-.378.29-.723.565-.998zm2.049.99a.75.75 0 0 0-1.059 0l-7.672 7.672a.75.75 0 0 0-.197.347l-.732 2.93-.002.01v.002l.008.011.011.008h.003l.009-.001 2.93-.733a.75.75 0 0 0 .348-.197l7.672-7.672a.75.75 0 0 0 0-1.059z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=HighlightChangesIcon24.js.map